// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e38998d","455":"f843c668","977":"5ea9fcd4"}[chunkId] + ".chunk.js";
};